/* eslint-disable react-compiler/react-compiler */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useApi } from "@platform/api";

function usePrepareClientFormState(runOnInit = false, brokerId = null) {
  const api = useApi();
  const [prepareClientFormState, setPrepareClientFormState] = useState({
    loading: false,
    data: null,
    error: null,
  });

  useEffect(() => {
    if (
      !runOnInit ||
      prepareClientFormState.data ||
      prepareClientFormState.loading
    ) {
      return;
    }
    setPrepareClientFormState((prev) => ({ ...prev, loading: true }));
    api
      .post("/brokerportal/v1/prepareClientForm", {
        omitClients: true,
        ...(brokerId ? { brokerId } : {}),
      })
      .then((res) =>
        setPrepareClientFormState((prev) => ({
          ...prev,
          loading: false,
          data: res.data,
        })),
      );
  }, [runOnInit, prepareClientFormState.loading, prepareClientFormState.data]);

  return prepareClientFormState;
}

export default usePrepareClientFormState;
